// raised to 2000000000 to hide nav bar of https://1899.jp/hotels/tokyo/en/
// max allowed value is 2147483647
const DEFAULT_Z_INDEX = 2000000000;
export const MAIN_BUTTON_SIZE_MOBILE = 72;
export const MAIN_BUTTON_SIZE_DESKTOP = 80;

const defaultCSS = {
  'box-sizing': 'border-box',
  margin: 0,
  padding: 0,
  border: 0,
  font: 'normal 13px/13px "Arial", sans-serif',
  'vertical-align': 'baseline',
  display: 'block',
  background: 'transparent',
  color: 'black',
  transform: 'none',
  animation: 'none',
  'text-decoration': 'none',
  'text-emphasis': 'none',
  'text-shadow': 'none',
  'letter-spacing': 'normal',
  'text-indent': 0,
  'text-align': 'left',
  'text-justify': 'none',
  opacity: 1,
};

let baseZIndex = DEFAULT_Z_INDEX;
export const getBaseZIndex = () => baseZIndex;
export const setBaseZIndex = zIndex => {
  if (typeof zIndex === 'number') baseZIndex = zIndex;
};

const widgetDesign = {
  defaultStyle: defaultCSS,
  textBox: (align = 'right', bubbleBottomMargin = 10, isVisible = true) =>
    Object.assign({}, defaultCSS, {
      position: 'fixed',
      bottom: `${(bubbleBottomMargin ?? 10) + 90}px`,
      left: align === 'left' ? '10px' : 'auto',
      right: '10px',
      width: '250px',
      height: '120px',
      'border-radius': '10px',
      'box-shadow': '0px 2px 10px 1px #b5b5b5',
      background: 'white',
      'z-index': getBaseZIndex(),
      display: isVisible ? 'block' : 'none',
    }),
  chatStyle: (align = 'right') =>
    Object.assign({}, defaultCSS, {
      position: 'fixed',
      right: align === 'left' ? 'auto' : '10px',
      'border-radius': '10px',
      overflow: 'hidden',
      'box-shadow': '0px 2px 10px 1px #b5b5b5',
      width: '350px',
      'max-height': '600px',
      'min-height': '350px',
      height: 'calc(100% - 20px)',
      bottom: '10px',
      background: 'white',
      'z-index': getBaseZIndex() - 1,
      top: 'auto',
      left: align === 'left' ? '10px' : 'auto',
    }),
  chatFullscreenStyle: Object.assign({}, defaultCSS, {
    position: ['fixed', 'important'],
    'border-radius': '0',
    'box-shadow': '0px 2px 10px 1px #b5b5b5',
    width: 'auto',
    height: 'auto',
    'max-height': 'none',
    'min-height': 'none',
    top: ['0', 'important'],
    bottom: ['0', 'important'],
    right: ['0', 'important'],
    left: ['0', 'important'],
    'z-index': getBaseZIndex() - 2,
    background: 'white',
  }),
  dialogueWrapper: Object.assign({}, defaultCSS, {
    display: 'flex',
    'flex-direction': 'column',
    'justify-content': 'center',
    'align-items': 'center',
  }),
  dialogueTop: Object.assign({}, defaultCSS, {
    display: 'flex',
    'justify-content': 'center',
    'align-items': 'center',
    width: '100%',
    'border-bottom': '1px solid lightgrey',
    padding: '10px',
  }),
  dialogueBottom: Object.assign({}, defaultCSS, {
    width: '250px',
    height: '50px',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    cursor: 'pointer',
  }),
  dialogueIcon: Object.assign({}, defaultCSS, {
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    'border-radius': '50%',
    'background-color': '#3e58f5',
    width: '50px',
    height: '50px',
  }),
  dialogueIconImage: Object.assign({}, defaultCSS, {
    width: '40px',
    height: '40px',
  }),
  dialogueCustomIcon: Object.assign({}, defaultCSS, {
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    'border-radius': '50%',
    width: '50px',
    height: '50px',
  }),
  dialogueCustomIconImage: Object.assign({}, defaultCSS, {
    width: '100%',
    height: '100%',
  }),
  dialogueTextWrapper: Object.assign({}, defaultCSS, {
    display: 'flex',
    flex: '2',
    'align-items': 'flex-start',
    'justify-content': 'center',
    'flex-direction': 'column',
    'margin-left': '20px',
  }),
  dialogueTextMainText: Object.assign({}, defaultCSS, {
    'font-size': '15px',
    'font-weight': '800',
    'line-height': '18px',
    'margin-bottom': '5px',
  }),
  dialogueTextSubText: Object.assign({}, defaultCSS, {
    'white-space': 'nowrap',
  }),
  dialogueCloseButton: Object.assign({}, defaultCSS, {
    cursor: 'pointer',
    '-webkit-tap-highlight-color': 'rgba(255, 255, 255, 0)',
    position: 'absolute',
    right: '2px',
    top: '3px',
    'font-size': '16px',
    width: '1.5em',
    height: '1.5em',
    'vertical-align': 'middle',
    'text-align': 'center',
    'padding-left': '1px',
  }),
  dialogueBottomText: (color = '#3e58f5') =>
    Object.assign({}, defaultCSS, {
      color,
      cursor: 'pointer',
    }),
  chatWidgetWrapper: (align = 'right', bottomMargin = 10, scale = 1) =>
    Object.assign({}, defaultCSS, {
      position: 'fixed',
      bottom: `${bottomMargin ?? 10}px`,
      right: align === 'left' ? 'auto' : '10px',
      'z-index': getBaseZIndex(),
      left: align === 'left' ? '10px' : 'auto',
      transform: `scale(${scale})`,
      'transform-origin': align === 'left' ? 'bottom left' : 'bottom right',
    }),
  chatWidget: (backgroundColor, isMobile) => {
    const size = `${isMobile ? MAIN_BUTTON_SIZE_MOBILE : MAIN_BUTTON_SIZE_DESKTOP}px`;
    return {
      ...defaultCSS,
      width: size,
      height: size,
      'background-color': backgroundColor || '#3e58f5',
      'border-radius': '50px',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'flex-start',
      'flex-direction': 'column',
      'box-shadow': '0px 2px 10px 1px #b5b5b5',
      cursor: 'pointer',
      '-webkit-tap-highlight-color': 'transparent',
      position: 'relative',
      overflow: 'hidden',
    };
  },
  chatWidgetImage: (isMobile, bubbleText, customImageUrl) => {
    const screenType = isMobile ? 'mobile' : 'desktop';
    const textType = !bubbleText ? 'noText' : 'withTextBelow';
    const isMultilineText = /<br\s*\/?>/i.test(bubbleText);
    const imageType = customImageUrl ? 'customImage' : 'defaultImage';
    const { size, marginTop } = {
      mobile: {
        noText: {
          defaultImage: {
            size: '32px',
            marginTop: '18px',
          },
          customImage: {
            size: '50px',
            marginTop: '8px',
          },
        },
        withTextBelow: {
          defaultImage: {
            size: '24px',
            marginTop: '12px',
          },
          customImage: {
            size: '36px',
            marginTop: '6px',
          },
        },
      },
      desktop: {
        noText: {
          defaultImage: {
            size: '36px',
            marginTop: '20px',
          },
          customImage: {
            size: '56px',
            marginTop: '8px',
          },
        },
        withTextBelow: {
          defaultImage: {
            size: '28px',
            marginTop: '15px',
          },
          customImage: {
            size: '42px',
            marginTop: '7px',
          },
        },
      },
    }[screenType][textType][imageType];

    return {
      ...defaultCSS,
      width: size,
      height: size,
      'min-height': size, // override min-height: 1px; set on Otani website, causing issues
      'margin-top': marginTop,
      'margin-bottom': isMultilineText ? '0' : '4px',
      position: 'relative',
      top: isMultilineText ? '-3px' : 'auto',
      background: 'inherit',
    };
  },
  chatWidgetText: Object.assign({}, defaultCSS, {
    color: 'white',
    'font-size': '8px',
    'text-align': 'center',
    backgroundColor: 'transparent',
    position: 'relative',
  }),
  chatLoadingAnimationContainerStyle: Object.assign({}, defaultCSS, {
    position: 'relative',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    'flex-direction': 'column',
  }),
  chatLoadingImageStyle: Object.assign({}, defaultCSS, {
    width: '130px',
    opacity: 0,
  }),
  chatLoadingCircleContainerStyle: Object.assign({}, defaultCSS, {
    display: 'flex',
    'flex-direction': 'row',
    'align-items': 'center',
    'justify-content': 'space-evenly',
    width: '200px',
    'margin-top': '30px',
  }),
  chatLoadingCircleStyle: Object.assign({}, defaultCSS, {
    width: '20px',
    height: '20px',
    'background-color': '#f5eee7',
    'border-radius': '50%',
    opacity: 0,
  }),
  chatNotificationBadge: {
    ...defaultCSS,
    color: 'white',
    'border-radius': '10px',
    width: '21px',
    height: '18px',
    position: 'absolute',
    'background-color': 'red',
    right: '1px',
    top: '-3px',
    display: 'none',
    'align-items': 'center',
    'justify-content': 'center',
    'z-index': getBaseZIndex() + 1,
    opacity: 0,
  },
};

export default widgetDesign;
